import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { delay, map, take } from 'rxjs/operators';

export const accessAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  /**
  Check if user is Authenticated
  if not, check if faqsAccessToken is in localstorage, return true
  */
  return authService.user.pipe(
    delay(1400),
    take(1),
    map((user) => {
      const isAuth = !!user;
      if (isAuth) {
        return true;
      } else if (authService.checkMobileLocalStorageAuth()) {
        return true;
      }
      router.navigate(['/home']);
      return false;
    })
  );
};
